import { Spinner } from '@tempmee/react';
import { FloatingContainer, Screen } from '../Container';

export const CardSpinner = () => (
  <Screen data-testid="screen">
    <FloatingContainer borderRadius={0} data-testid="floating-container" height="100%">
      <Spinner centered variant="default" size="md" />
    </FloatingContainer>
  </Screen>
);
